import styled from "styled-components";
import { theme } from "../../constants/StyledComponents";

export const StyledUserPanel = styled.div`
  padding: 8px;
  border-radius: ${theme.variables.border_radius_1};
  border-color: white;
  min-width: ${theme.variables.user_panel_width};
  box-sizing: border-box;
  & .avatar-name-wrapper {
    cursor: pointer;
    margin: 15px 0px 15px 0px;
  }
  & .link-list {
    margin-bottom: 15px;
  }
`;

export const StyledImpersonateContainer = styled.div`
  & > div:last-child > div {
    padding: 0px;

    & > .impersonate-search {
      margin-top: 15px;
    }
  }
`;

export const StyledPersonalAccountContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
